module.exports = __webpack_public_path__ + "static/logo_path-702207c6907f3784309539bb629f8b87.svg";